import React, { FC } from "react";
import Highlight from "../highlight";

const URLList: FC<{ urls?: string[] }> = ({ urls = [] }) => (
  <>
    {urls.map((url, index) => (
      <React.Fragment key={index}>
        {" "}
        <Highlight link={`http://${url}`}>{url}</Highlight>
        {index < urls.length - 1 ? <>,</> : <> </>}
      </React.Fragment>
    ))}
  </>
);

export default URLList;
